<mat-sidenav-container id="shared-side-nav-container" class="main-container">
  <mat-sidenav mode="side" id="shared-side-nav-wrapper" opened class="side-nav">
    <mat-nav-list>
      <a mat-list-item class="mat-list-item" routerLink="." > <app-text
        id="shared-side-nav-text"
        class="nav-title"
        [textStyleType]="'nav-option'"
        >{{ title }}</app-text></a>     
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content id="shared-side-nav-content">
    <router-outlet id="shared-side-nav-content-router-outlet"></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
